import InputCustom from '../atoms/input/InputCustom'
import CheckBoxCustom from '../atoms/checkbox/CheckBox'
import DateCustom from '../atoms/input/DateCustom'
import { Autocomplete, Chip, TextField } from '@mui/material'
import { ALL_STACKS } from '../../util/constants'
import {
	getVendorBusinessTypes,
	normalizeBusinessTypes,
} from '../../util/businessTypes'

const LABEL_STYLE = {
	font: 'var(--body-font-three)',
	color: 'var(--secondary-Text)',
}

export default function AddVendor({ vendor, setVendor }) {
	const businessTypes = getVendorBusinessTypes(vendor)

	const handleBusinessTypesChange = (_event, values) => {
		setVendor((prev) => ({
			...(prev || {}),
			businessTypes: normalizeBusinessTypes(values),
			customBusinessType: '',
		}))
	}

	return (
		<div
			style={{
				display: 'flex',
				flexDirection: 'column',
				gap: '12px',
			}}
		>
			<InputCustom
				label="Business Name"
				placeholder="Enter Business Name"
				name="businessName"
				type="text"
				data={vendor}
				value={vendor?.businessName}
				setDataFunction={setVendor}
				labelStyle={LABEL_STYLE}
			/>
			<div style={{ width: '100%' }}>
				<label
					htmlFor="vendor-business-types"
					style={{
						display: 'block',
						marginBottom: '5px',
						fontSize: '14px',
						fontWeight: '500',
						...LABEL_STYLE,
					}}
				>
					Business Type
				</label>
				<Autocomplete
					multiple
					freeSolo
					options={ALL_STACKS}
					value={businessTypes}
					onChange={handleBusinessTypesChange}
					filterSelectedOptions
					renderTags={(values, getTagProps) =>
						values.map((option, index) => {
							const { key, ...tagProps } = getTagProps({ index })
							return (
								<Chip
									key={key}
									label={option}
									size="small"
									{...tagProps}
								/>
							)
						})
					}
					renderInput={(params) => (
						<TextField
							{...params}
							id="vendor-business-types"
							placeholder={
								businessTypes.length
									? 'Add another business type'
									: 'Select or enter business type'
							}
							inputProps={{
								...params.inputProps,
								'data-cy': 'vendor-business-types',
							}}
						/>
					)}
				/>
			</div>
			<InputCustom
				label="Vendor Email *"
				placeholder="Enter Vendor Email"
				name="email"
				type="email"
				data={vendor}
				value={vendor?.email}
				setDataFunction={setVendor}
				labelStyle={LABEL_STYLE}
			/>
			<InputCustom
				label="Vendor Phone"
				placeholder="Enter Vendor Phone"
				name="phone"
				type="text"
				data={vendor}
				value={vendor?.phone}
				setDataFunction={setVendor}
				labelStyle={LABEL_STYLE}
			/>

			<InputCustom
				label="Quote Amount *"
				value={vendor?.quote || ''}
				data={vendor}
				setDataFunction={setVendor}
				type="number"
				id="quote"
				name="quote"
				inputProps={{ min: 0 }}
				labelStyle={LABEL_STYLE}
			/>
			<InputCustom
				label="Deposit Amount *"
				value={vendor?.deposit || ''}
				data={vendor}
				setDataFunction={setVendor}
				type="number"
				id="deposit"
				name="deposit"
				inputProps={{ min: 0 }}
				labelStyle={LABEL_STYLE}
			/>
			<CheckBoxCustom
				label="Deposit paid?"
				checked={vendor?.isDepositPaid || false}
				onChange={(e) =>
					setVendor((prev) => ({
						...prev,
						isDepositPaid: e.target.checked,
					}))
				}
				sx={{
					'&.MuiButtonBase-root': {
						margin: '0 8px 0 0 !important',
					},
					'& .MuiTypography-root': {
						display: '-webkit-box',
						maxWidth: '100%',
						'-webkit-line-clamp': '1',
						'-webkit-box-orient': 'vertical',
						overflow: 'hidden',
						textOverflow: 'ellipsis',
					},
				}}
				labelColor={LABEL_STYLE.color}
			/>
			<DateCustom
				label="Payment due date"
				name="paymentDueDate"
				value={vendor?.paymentDueDate || null}
				data={vendor}
				setDataFunction={setVendor}
				data_cy="vendor-payment-due-date"
			/>
		</div>
	)
}
